import { render, staticRenderFns } from "./CoTwoGeneratorEnergyForm.vue?vue&type=template&id=67456c3e&scoped=true&"
import script from "./CoTwoGeneratorEnergyForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoGeneratorEnergyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67456c3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67456c3e')) {
      api.createRecord('67456c3e', component.options)
    } else {
      api.reload('67456c3e', component.options)
    }
    module.hot.accept("./CoTwoGeneratorEnergyForm.vue?vue&type=template&id=67456c3e&scoped=true&", function () {
      api.rerender('67456c3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/green/form/CoTwoGeneratorEnergyForm.vue"
export default component.exports